import React from 'react';

const ShopDrawingPage = () => {
  return (
    <div style={{ padding: '100px 20px', textAlign: 'center' }}>
      <h1>Shop Drawing</h1>
      <p>Content coming soon...</p>
    </div>
  );
};

export default ShopDrawingPage;
